import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import {
  SNACKBAR_INITIAL_STATE,
  SnackBarState
} from '@store/snackbar-store/snackbar.model.ts';

const useSnackbarStore = create<SnackBarState>()(
  devtools(
    (set) => ({
      ...SNACKBAR_INITIAL_STATE,

      showSnackbar: (message, type) =>
        set({
          snackbarOpen: true,
          snackbarMessage: message,
          snackbarType: type
        }),

      hideSnackbar: () =>
        set({
          snackbarOpen: false,
          snackbarMessage: ''
        })
    }),
    { name: 'SnackbarStore' }
  )
);

export default useSnackbarStore;
